import type NonNegativeNumber from '../non-negative-number';
import { assertIsInstanceOfNonNegativeNumber } from '../assertions';

interface ITotals {
	readonly amount: NonNegativeNumber;
	readonly discount: NonNegativeNumber;
	readonly subtotal: NonNegativeNumber;
	readonly vat: NonNegativeNumber;
}

export default class Totals {
	public get amount(): NonNegativeNumber {
		return this.#amount;
	}

	public get discount(): NonNegativeNumber {
		return this.#discount;
	}

	public get subtotal(): NonNegativeNumber {
		return this.#subtotal;
	}

	/**
	 * Returns the subTotal as a danish formatted string with the following format 6.123,56 kr
	 *
	 * We can easily convert this to a method that accepts a locale and currency parameter so it could be more dynamic.
	 */
	public get subTotalAsCurrency(): string {
		return new Intl.NumberFormat('da-DK', {
			currency: 'DKK',
			style: 'currency',
		}).format(this.subtotal.value);
	}

	public get vat(): NonNegativeNumber {
		return this.#vat;
	}

	#amount: NonNegativeNumber;
	#discount: NonNegativeNumber;
	#subtotal: NonNegativeNumber;
	#vat: NonNegativeNumber;
	public constructor({ amount, discount, subtotal, vat }: ITotals) {
		assertIsInstanceOfNonNegativeNumber(amount);
		this.#amount = amount;
		assertIsInstanceOfNonNegativeNumber(discount);
		this.#discount = discount;
		assertIsInstanceOfNonNegativeNumber(subtotal);
		this.#subtotal = subtotal;
		assertIsInstanceOfNonNegativeNumber(vat);
		this.#vat = vat;
	}
}
